<script>
import BaseAutocomplete from '@/components/elements/Base/BaseAutocomplete';
import PersonService from '@/services/person-service';
import { isNil } from 'lodash';

export default {
	extends: BaseAutocomplete,
	name: 'autocomplete-person',
	props: {
		selected: {
			type: Object|Number,
			default: null
		},
	},
	methods: {
		itemHasChanged(person) {
			this.$emit('update:person', person);
		},
		customLabel({ full_name, code }) {
			if (isNil(code)) return `${full_name}`;
			return `${full_name} (${code})`;
		},
		request() {
			return PersonService.getAll;
		},

		/**
		 * Set Selection
		 *
		 * Override set selection method from BaseAutocomplete.
		 * If selected (initial) value is an integer, search for the corresponding user.
		 */
		setSelection() {
			if(Number.isInteger(this.selected)) {
				this.isLoading = true;

				PersonService.getOne(this.selected)
					.then(
						person => {
							this.currentSelection = person;
							this.isLoading = false;
						}
					)
					.catch(
						error => {
							this.currentSelection = null;
							this.isLoading = false;
						}
					);
			} else {
				this.currentSelection = this.selected;
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// AutocompletePerson.vue?9d600d5a